export default {
    approvals: "Zulassungen",
    delegates: "Delegierte",
    employees: "Mitarbeiter"
}